import { axiosServices } from "./axiosServices";
import {urlConstants} from "../constant";
import axios from 'axios';
import { UserObj } from "./localStarage";
const apiToken = UserObj? UserObj.accessToken: '';

export const chatServices = {addComment, getAllComment };

function addComment(param, id) {
  return axiosServices
    .postAxios(`/v1/common/comments/add-comment`, param)
    .then((res) => { 
      return res;
    });
}

function getAllComment(param) {
  return axiosServices
    .getAxios(`/v1/common/comments/${param}`)
    .then((res) => { 
      return res;
    });
}

// function getAllComment(bodyData, param) {
//     let url = `/v1/common/comments/?pageNo=2`;

//     let data = JSON.stringify(bodyData);
      
//     let config = {
//         method: 'get',
//         url: urlConstants.BASE_URI_DEV + url,
//         headers: {
//             "Authorization" : `Bearer ${apiToken}`,
//             'Content-Type': 'application/json'
//         },
//         data : bodyData
//     }; 
//     return axios(config).then(
//         res => { // then print response status
//         return res;
//     })
// }
